export const courseListData = [
  {
    CourseName:
      "Information About UI/UX Design Degree ",
    Students: "600",
    key:1,
    Price: "$160",
    Ratings: "4.5 (300)",
    Status: "Published",
    Img: "course-01.jpg",
  },
  {
    CourseName:
      "Wordpress for Beginners - Master Wordpress Quickly ",
    Students: "500",
    key:2,
    Price: "$180",
    Ratings: "4.2 (430)",
    Status: "Pending",
    Img: "course-02.jpg",
  },
  {
    CourseName:
      "Sketch from A to Z (2024): Become an app designer ",
    Students: "300",
    key:3,
    Price: "$200",
    Ratings: "4.7 (140)",
    Status: "Draft",
    Img: "course-03.jpg",
  },
  {
    CourseName:
      "Build Responsive Real World Websites with Crash Course ",
    Students: "400",
    key:4,
    Price: "$220",
    Ratings: "4.4 (260)",
    Status: "Published",
    Img: "course-04.jpg",
  },
  {
    CourseName:
      "Learn JavaScript and Express to become a Expert ",
    Students: "700",
    key:5,
    Price: "$170",
    Ratings: "4.8 (180)",
    Status: "Published",
    Img: "course-05.jpg",
  },
  {
    CourseName:
      "Introduction to Python Programming ",
    Students: "450",
    key:6,
    Price: "$150",
    Ratings: "4.8 (180)",
    Status: "Published",
    Img: "course-06.jpg",
  },
  {
    CourseName:
      "Build Responsive Websites with HTML5 and CSS3 ",
    Students: "620",
    key:7,
    Price: "$130",
    Ratings: "4.9 (510)",
    Status: "Published",
    Img: "course-07.jpg",
  },
  {
    CourseName:
      "Information About Photoshop Design Degree ",
    Students: "550",
    key:8,
    Price: "$190",
    Ratings: "4.6 (400)",
    Status: "Published",
    Img: "course-08.jpg",
  },
  {
    CourseName:
      "C# Developers Double Your Coding with Visual Studio ",
    Students: "240",
    key:9,
    Price: "$140",
    Ratings: "4.1 (180)",
    Status: "Published",
    Img: "course-09.jpg",
  },
  {
    CourseName:
      "Complete HTML, CSS and Javascript Course ",
    Students: "380",
    key:10,
    Price: "$110",
    Ratings: "4.3 (200)",
    Status: "Published",
    Img: "course-01.jpg",
  },
];
